import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const LightsIcon = ({size = 24,...props}) => (
    <SvgIcon viewBox="0 0 512 512" {...props} style={{ width: size, height: size }}>
      <svg viewBox="0 0 512.168 512.168" >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <g transform="translate(1 1)">
        <g>
          <g>
            <path d="M255,75.884c-83.627,0-161.28,28.16-209.067,75.947C15.213,181.697-1,217.537-1,255.084c0,98.133,115.2,179.2,256,179.2 c3.413,0,7.68-2.56,8.533-5.973c34.133-113.493,34.133-232.96,0-346.453C261.827,78.444,258.413,75.884,255,75.884z M249.027,418.071c-128.853-2.56-232.96-74.24-232.96-162.133c0-33.28,14.507-64.853,41.813-92.16 c43.52-42.667,114.347-69.12,191.147-70.827C279.747,199.617,279.747,311.404,249.027,418.071z"/> 
            <path d="M505.88,324.204l-187.733-76.8c-4.267-2.56-9.387,0-11.093,4.267c-2.56,4.267,0,9.387,4.267,11.093l187.733,76.8 c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,6.827-1.707,7.68-5.12C512.707,331.031,510.147,325.911,505.88,324.204z"/> 
            <path d="M311.32,177.431l187.733,76.8c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,6.827-1.707,7.68-5.12 c2.56-4.267,0-9.387-4.267-11.093l-187.733-76.8c-4.267-2.56-9.387,0-11.093,4.267 C304.493,170.604,307.053,175.724,311.32,177.431z"/> 
            <path d="M505.88,409.537l-187.733-76.8c-4.267-2.56-8.533,0-11.093,4.267s0,9.387,4.267,11.093l187.733,76.8 c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,6.827-1.707,7.68-5.12C512.707,416.364,510.147,411.244,505.88,409.537z"/> 
        </g>
            </g>
        </g>
  </g>
</svg>

  </SvgIcon>
);

export default LightsIcon;
